"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const dymostore_1 = require("./dymostore");
const constraintwriter_1 = require("./constraintwriter");
const constraintloader_1 = require("./constraintloader");
class SuperStore extends dymostore_1.DymoStore {
    constructor() {
        super(...arguments);
        this.constraintWriter = new constraintwriter_1.ConstraintWriter(this);
        this.constraintLoader = new constraintloader_1.ConstraintLoader(this);
        this.activeConstraints = new Map();
    }
    addConstraint(ownerUri, constraint) {
        return this.constraintWriter.addConstraint(ownerUri, constraint);
    }
    addVariable(variable) {
        return this.constraintWriter.addVariable(variable);
    }
    activateNewConstraints(constraintUris) {
        let unloadedUris = _.difference(constraintUris, [...this.activeConstraints.keys()]);
        let constraints = this.constraintLoader.loadConstraints(unloadedUris);
        constraints.forEach(c => c.maintain(this));
        unloadedUris.forEach((u, i) => this.activeConstraints.set(u, constraints[i]));
        return unloadedUris;
    }
    deactivateConstraints(constraintUris) {
        let constraints = constraintUris.map(c => this.activeConstraints.get(c));
        constraints.forEach(c => c ? c.stopMaintaining() : null);
    }
}
exports.SuperStore = SuperStore;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/io/superstore.js
// module id = 642
// module chunks = 3